module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/coj_f-7-0e81a2713419902a2586482d004a426e.jpg";